module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vcirc1-a967ddb583f3cce5678323252f4dcf00.jpg";